export default {
	layout: "winLose",
	doesntHaveTime: true,
}
